import {useTranslation} from "react-i18next";
import {checkIn} from "../../api/eventApi";

export default function CheckInButton(
    {
        id,
        isUserCheckedIn,
        registrationRequired,
        isUserRegistered,
        isStarted,
        eventDataUpdate
    }
) {
    const { t } = useTranslation();

    if (registrationRequired && !isUserRegistered) {
        return null;
    }

    return (
        <button onClick={() => checkIn(id, () => eventDataUpdate({type: 'checkIn'}))} className="btn-conference-page wide btn-primary" disabled={isUserCheckedIn || !isStarted}>
            { isUserCheckedIn ? t('conferences.conference.buttons.checkedIn') : t('conferences.conference.buttons.checkIn') }
        </button>
    )
}
